import { render, staticRenderFns } from "./ModalSocorroRota.vue?vue&type=template&id=1b471e6d&scoped=true&"
import script from "./ModalSocorroRota.vue?vue&type=script&lang=js&"
export * from "./ModalSocorroRota.vue?vue&type=script&lang=js&"
import style0 from "./ModalSocorroRota.vue?vue&type=style&index=0&id=1b471e6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b471e6d",
  null
  
)

export default component.exports